import DiffIcon from '@components/icons/DiffIcon.svg';
import { routes } from '@routes';
import { AdminTranscriptReviewService } from 'app/API';
import { useEffect, useState } from 'react';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { MenuItemButton } from '../MoreActionsMenu/components/MenuItemButton';

type TFixturesSummaryWrapper = {
  body?: { hasArtifacts?: boolean };
  ok: boolean;
};

export const TranscriptReviewButton = () => {
  const { job, metadata } = usePageContext();
  const [hasReviewFixtures, setHasReviewFixtures] = useState(false);

  useEffect(() => {
    if (!job?.id || (!job.enhancedCharged && !metadata)) {
      setHasReviewFixtures(false);
      return;
    }

    let isMounted = true;

    AdminTranscriptReviewService.getStyleFixFixtureSummary({ jobId: job.id })
      .then((response) => {
        if (!isMounted) {
          return;
        }
        const wrapped = response as unknown as TFixturesSummaryWrapper;
        setHasReviewFixtures(wrapped.ok && !!wrapped.body?.hasArtifacts);
      })
      .catch(() => {
        if (isMounted) {
          setHasReviewFixtures(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [job?.enhancedCharged, job?.id, metadata]);

  if (!job || !hasReviewFixtures) {
    return null;
  }

  const transcriptReviewUrl = `${routes.adminTranscriptReviewJob.make(job.id)}?source=s3`;

  return (
    <MenuItemButton
      title="Open Transcript Review"
      onClick={() => window.open(transcriptReviewUrl, '_blank', 'noopener,noreferrer')}
    >
      <DiffIcon />
      Transcript Review
    </MenuItemButton>
  );
};
